// Chakra imports
import {
  Skeleton,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Flex,
  Icon,
  Text,
} from "@chakra-ui/react";
import { MdDashboard, MdInsights as MdAnalytics } from "react-icons/md";
import React, { useState } from "react";
import { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { useLocation, useNavigate } from "react-router-dom";

import { deleteModalState } from "atoms/deleteModalState";
import LoadingSpinner from "components/feedback/LoadingSpinner";
import DashboardOverviewTab from "./components/DashboardOverviewTab";
import DashboardAnalyticsTab from "./components/DashboardAnalyticsTab";
import PerformanceReportTab from "./components/PerformanceReportTab";
import RoleBasedRender from "components/wrappers/roleBasedRender";
import { onlyUAdmins } from "utils/accessLevels";

const loadingData = [
  {
    Name: <Skeleton />,
    PinCode: <LoadingSpinner />,
    PhoneNumber: <LoadingSpinner />,
  },
];
const DashboardTabs = () => {
  const setDeleteModal = useSetRecoilState(deleteModalState);
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const location = useLocation();
  const navigation = useNavigate();
  useEffect(() => {
    setDeleteModal(false);
  }, []);

  const clickHandler = (x) => {
    if (x === 0) {
      navigation(`/admin/dashboard/overview`);
    } else if (x === 1) {
      navigation(`/admin/dashboard/analytics`);
    } else if (x === 2) {
      navigation(`/admin/dashboard/performancereport`);
    }
  };

  useEffect(() => {
    if (location.pathname === "/admin/dashboard/overview") {
      setActiveTabIndex(0);
    } else if (location.pathname === "/admin/dashboard/analytics") {
      setActiveTabIndex(1);
    } else if (location.pathname === "/admin/dashboard/performancereport") {
      setActiveTabIndex(2);
    }
  }, [location]);

  return (
    <Tabs
      variant="unstyled"
      isLazy={true}
      index={activeTabIndex}
      mt={{ base: "0", xl: "70px" }}
    >
      <TabList
        gap={4}
        px={1}
        py={2}
        bg="rgba(255, 255, 255, 0.6)"
        backdropFilter="blur(12px)"
        borderRadius="xl"
        // boxShadow="0 4px 20px rgba(35, 169, 121, 0.08)"
        border="1px solid rgba(35, 169, 121, 0.15)"
        position="relative"
        overflow="hidden"
        _before={{
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "100%",
          // background:
          //   "linear-gradient(90deg, rgba(35, 169, 121, 0.05) 0%, rgba(255, 255, 255, 0) 100%)",
          zIndex: 0,
          pointerEvents: "none",
        }}
      >
        <Tab
          _focus={{ boxShadow: "none" }}
          onClick={() => clickHandler(0)}
          borderRadius="lg"
          px={5}
          py={2.5}
          fontWeight="500"
          color="gray.600"
          // transition="all 0.06s ease-out"
          position="relative"
          zIndex="1"
          _selected={{
            bg: "rgba(35, 169, 121, 0.15)",
            color: "brand.500",
            fontWeight: "600",
            boxShadow: "0 2px 4px rgba(35, 169, 121, 0.1)",
            // borderBottom: "2px solid #23A979",
          }}
          _hover={{
            bg: "rgba(35, 169, 121, 0.08)",
            color: "brand.500",
          }}
        >
          <Flex align="center" gap={2}>
            <Icon as={MdDashboard} boxSize={5} />
            <Text>Overview</Text>
          </Flex>
        </Tab>
        <Tab
          _focus={{ boxShadow: "none" }}
          onClick={() => clickHandler(1)}
          borderRadius="lg"
          px={5}
          py={2.5}
          fontWeight="500"
          color="gray.600"
          // transition="all 0.06s ease-out"
          position="relative"
          zIndex="1"
          display={{ base: "none", md: "flex" }}
          _selected={{
            bg: "rgba(35, 169, 121, 0.15)",
            color: "brand.500",
            fontWeight: "600",
            boxShadow: "0 2px 4px rgba(35, 169, 121, 0.1)",
            // borderBottom: "2px solid #23A979",
          }}
          _hover={{
            bg: "rgba(35, 169, 121, 0.08)",
            color: "brand.500",
          }}
        >
          <Flex align="center" gap={2}>
            <Icon as={MdAnalytics} boxSize={5} />
            <Text>Analytics</Text>
          </Flex>
        </Tab>
        <RoleBasedRender roles={onlyUAdmins}>
          {/* <Tab _focus={{ boxShadow: "none" }} onClick={() => clickHandler(2)}>
            Performance Report
          </Tab> */}
        </RoleBasedRender>
      </TabList>
      <TabPanels>
        <TabPanel>
          <DashboardOverviewTab />
        </TabPanel>
        <TabPanel>
          <DashboardAnalyticsTab />
        </TabPanel>
        <RoleBasedRender roles={onlyUAdmins}>
          {/* <TabPanel>
            <PerformanceReportTab />
          </TabPanel> */}
        </RoleBasedRender>
      </TabPanels>
    </Tabs>
  );
};

export default DashboardTabs;
